module.exports = __webpack_public_path__ + "img/product-shot_08.35c62ab4.jpg";